import { useState } from "react";
import { Box, Flex, Spinner, Stack, Text } from "@chakra-ui/react";
import { DateTime } from "luxon";
import PeriodSelector, { IPeriod } from "@ui/components/datetime";
import { useSelf } from "@ui/services/useUser";
import { useEmployeeMealSummary } from "@/services/useMealServing";
import { getMealIcon } from "./Form/GuestBookingDetailsForm";
import useIsMobile from "@ui/hooks/useIsMobile";

export const MealConsumed = () => {
  const { data: me } = useSelf();

  const [period, setPeriod] = useState<IPeriod | undefined>({
    name: "This year",
    start: DateTime.now().minus({ months: 12 }),
    end: DateTime.now(),
  });

  const fromDate = period?.start;
  const toDate = period?.end;

  const { data, isLoading } = useEmployeeMealSummary(fromDate, toDate, me?.id);
  const isMobile = useIsMobile();

  return (
    <>
      {isLoading ? (
        <Box mt={6} textAlign="center">
          <Spinner size="lg" color="green.500" thickness="4px" />
          <Text mt={2} fontSize="sm" color="gray.500">
            Loading meal summary...
          </Text>
        </Box>
      ) : (
        <>
          <Box>
            {isMobile && (
              <Text
                fontWeight="semibold"
                fontSize="md"
                mt={6}
                mb={2}
                color="gray.700"
              >
                Meal Consumed Summary
              </Text>
            )}
            <PeriodSelector period={period} shifts={[]} onChange={setPeriod} />
            {data?.length === 0 ? (
              <Box mt={6} textAlign="center">
                <Text fontSize="sm" color="gray.500">
                  No meals have been served during the selected period.
                </Text>
              </Box>
            ) : (
              <Stack spacing={4} mt={4}>
                {data?.map((item: any, index: number) => {
                  const Icon = getMealIcon(item.meal);
                  return (
                    <Box
                      key={`${item.meal}-${index}`}
                      borderWidth="1px"
                      borderRadius="md"
                      px={4}
                      py={3}
                      bg="white"
                      boxShadow="sm"
                      borderColor="gray.200"
                      _hover={{ borderColor: "green.500", boxShadow: "md" }}
                    >
                      <Flex align="center" justify="space-between">
                        <Flex align="center" gap={2}>
                          {Icon && (
                            <Box as={Icon} boxSize={5} color="gray.700" />
                          )}
                          <Text fontWeight="medium" textTransform="capitalize">
                            {item.meal}
                          </Text>
                        </Flex>
                        <Text
                          fontSize="md"
                          color="gray.800"
                          fontWeight="semibold"
                        >
                          {item.count}
                        </Text>
                      </Flex>
                    </Box>
                  );
                })}
              </Stack>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default MealConsumed;
